export const environment = {
  GRAPHQL_URI: "https://databeez-jobs-api-47a4116fb363.herokuapp.com/graphql",
  API_URI: "https://databeez-jobs-api-47a4116fb363.herokuapp.com",
  // GRAPHQL_URI: "http://localhost:4000/graphql"
};
